import PDT from './PDT.vue';
import TicketCreateModal from '../../modules/tickets/dashboard/components/TicketCreateModal.vue';
import TapeDeliveryReceptionSheet from './delivery-reception-tapes/TapeDeliveryReceptionSheet.vue';
import EquipmentDepartureSheet from './equipments-departure/EquipmentDepartureSheet.vue';
import TicketsDashboard from '@/modules/tickets/dashboard/views/TicketsDashboard.vue';
import TicketDataTable from '@/modules/tickets/dashboard/components/TicketDataTable.vue';
import TicketFilter from '@/modules/tickets/dashboard/components/TicketFilter.vue';
import TicketsDayco from './TicketsDayco.vue';

export {
    PDT,
    TicketCreateModal,
    TicketDataTable,
    TicketFilter,
    TicketsDayco,
    TapeDeliveryReceptionSheet,
    EquipmentDepartureSheet,
    TicketsDashboard,
};
